import { useState } from 'react';

const faqs = [
  {
    question: '六合彩的基本玩法是什么？',
    answer: '六合彩是从1至49个号码中选出6个号码作为一注。每期开奖会搅出6个正选号码和1个特别号码。根据选中号码的数量对应不同奖金等级，头奖需要选中全部6个正选号码。',
  },
  {
    question: '如何选择正规可靠的六合彩平台？',
    answer: '选择正规六合彩平台需注意以下几点：查验平台是否持有香港赛马会官方授权或合法博彩牌照；查看用户真实评价和口碑；确认资金安全保障措施是否到位；测试客服响应速度和服务质量。优先推荐使用香港赛马会官方平台。',
  },
  {
    question: '六合彩的开奖时间和频率是怎样的？',
    answer: '六合彩通常每周开奖两次，具体时间以香港赛马会官方公布为准。遇到赛马日、特别节日或金多宝活动时，开奖日期可能有所调整。建议关注官方网站获取最新开奖日程。',
  },
  {
    question: '什么是复式投注？有什么优势？',
    answer: '复式投注是指选择多于6个号码进行投注，系统会自动组合所有可能的6个号码组合。例如选择7个号码共有7注。复式投注的优势在于显著提高了中奖概率，但成本也会相应增加。',
  },
  {
    question: '参与六合彩需要注意什么？',
    answer: '参与六合彩应保持理性态度，将其视为娱乐活动而非投资。建议设定预算上限、不借贷投注、不迷信"必中"技巧、及时止损。只通过正规平台参与，远离非法赌博。量力而行，享受过程。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm">关于六合彩的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-medium text-foreground-800 pr-4">{faq.question}</span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`px-5 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'pb-4 max-h-[500px]' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}